module.exports = __webpack_public_path__ + "img/11.d35bfd4d.png";